import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  maintenanceResObject: any;
  announcementObj: any;

  constructor() {}

  setMaintenanceRes(val: any) {
    this.maintenanceResObject = val;
  }

  getMaintenanceRes() {
    return this.maintenanceResObject;
  }
  setAnnouncement(val:any) {
    this.announcementObj = val;
  }
  getAnnouncement() {
    return this.announcementObj;
  }

}
